import axios from "axios";
import useApp from "./useApp";

const useAxios = () => {
  const { token } = useApp();
  return async (obj) => {
    const {
      headers = {},
      method,
      data = {},
      url,
      baseUrl = "https://api.v2.mkombozihealthcare.com/api",
      params = {},
    } = obj;
    try {
      let res = await axios({
        headers: { Authorization: `Bearer ${token}`, ...headers },
        method: method,
        url: `${baseUrl}/${url}`,
        data: data,
        params: params,
      });
      return res.data;
    } catch (e) {
      return "error";
    }
  };
};

export default useAxios;
